module.exports = __webpack_public_path__ + "static/scenario1-5ef0756edf191093d6d7477ffbc2be0d.png";